import { BiHome } from "react-icons/bi";

import { Stack, Text, Button, Box } from "@chakra-ui/react";

import { CenteredLayout } from "@/components/2/CenteredLayout";
import { OuterShell } from "@/components/2/Shell";

interface ErrorFallbackProps {
  error: unknown;
  eventId: string;
}

export const ErrorFallback = ({ error, eventId }: ErrorFallbackProps) => {
  const errorMessage = error instanceof Error ? error.message : String(error);

  return (
    <OuterShell>
      <CenteredLayout maxW="lg">
        <Stack gap="6">
          <Stack gap={{ base: "2", md: "3" }} textAlign="center">
            <Text color="fg.muted" fontWeight="semibold" fontSize="lg">
              Une erreur est survenue
            </Text>
            <Text color="fg.muted">
              Une erreur inattendue s'est produite. Nous nous excusons pour la gêne occasionnée.
            </Text>
            {errorMessage && (
              <Text color="fg.muted" fontSize="sm" fontFamily="mono">
                {errorMessage}
              </Text>
            )}
          </Stack>

          <Box borderWidth={1} borderColor="gray.300" borderRadius="md" p={3} bg="gray.50">
            <Text fontSize="xs" fontWeight="semibold" color="gray.600" mb={1}>
              Référence de l'erreur
            </Text>
            <Text fontSize="sm" fontFamily="mono" color="gray.800" userSelect="all">
              {eventId}
            </Text>
          </Box>
        </Stack>

        <Button asChild variant="outline" display="flex" alignItems="center" gap={2}>
          <a href="/">
            <BiHome />
            <Text>Retour à l'accueil</Text>
          </a>
        </Button>

        <Stack gap="3" justify="center">
          <Text textStyle="sm" color="fg.muted" textAlign="center">
            Si cette erreur persiste, rapproche-toi de ton manager.
          </Text>
        </Stack>
      </CenteredLayout>
    </OuterShell>
  );
};
